<div class="languages-selection">
    <app-centered-scrollable-content>
        <div class="languages">
            <div class="language" *ngFor="let l of languages">
                <app-tapable-terminal-card [size]="cardSize">
                    <app-icon-tile [title]="l.language!.name" [iconCSS]="'flag fi ' + l.country?.flagIcon" [iconScale]="cardSize/125"
                        (click)="setLanguage(l)">
                    </app-icon-tile>
                </app-tapable-terminal-card>
            </div>
        </div>
    </app-centered-scrollable-content>
</div>
